<template>
  <div class="bannerpartner">
    <img class="elevation-1" :src="img" :alt="title">
  </div>
</template>

<script>
export default {
  props: ['title', 'img']
}
</script>

<style>
  .bannerpartner{
    padding: 8px;
  }
</style>